// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Hot_o","badges":"styles_badges__ashSN"};